import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from "../../../../shared/shared.module";

@Component({
  selector: 'app-fees-amis',
  standalone: true,
  imports: [NgbNavModule, CommonModule, SharedModule],
  templateUrl: './fees-amis.component.html',
  styleUrls: ['./fees-amis.component.scss'],
})
export class FeesAmisComponent {
  active = 1;
  @Input() dep: any;
  @Input() colorText: any;
}
